export default __webpack_public_path__ + "static/media/bell.277a4af1.mp3";